import {MOTOR_CADASTROS_EVENTOS} from "src/utils/api-routes"
import {ServiceRequest} from "src/utils/service-request"


class EventosService {
    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    async getEventos(cetip, versao_documento, id_caracteristica) {
        const params = []

        if (id_caracteristica) {
            params.push(`id_caracteristica=${encodeURIComponent(id_caracteristica)}`)
        }

        if (cetip) {
            params.push(`cetip=${encodeURIComponent(cetip)}`)
        }

        if (versao_documento) {
            params.push(`versao_documento=${versao_documento}`)
        }

        const query = params.length ? `?${params.join("&")}` : ""
        return this.serviceRequest.get(`${MOTOR_CADASTROS_EVENTOS}${query}`)
    }
}

export default EventosService